import Login from "../containers/Login";

let AccountRoutes = [
    {
        path: '/account/login',
        forceAuth: false,
        container: Login,
        exact: false,
    }
]

export default AccountRoutes